module.exports = __webpack_public_path__ + "img/bjing@2x.8c59f891.png";